const productCategoriesMeta = {
  routeName: window._trans._menu.item.products,
  noPadding: true,
  requiredRoles: [],
};

export const productCategoriesRoutes = [
  {
    path: "/app/product-categories",
    component: () => import("vue-app/pages/PageProductsV2/PageProductsV2.vue"),
    meta: productCategoriesMeta,
  },
];
